import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SurveyContainer from './surveys/SurveyContainer';
import './App.css';
import AboutUs from './pages/AboutUs';
import ForCompanies from './pages/ForCompanies';
import Header from './components/Header';
import Profiles from './pages/Profiles';
import SurveyGuard from './surveys/SurveyGuard';
import Footer from './components/Footer';
import NormalizeUrl from './helpers/NormalizeUrl';

function App() {
  return (
    <Router>
      <NormalizeUrl />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/surveys/:testSlug"
          element={
            <SurveyGuard>
              <SurveyContainer />
            </SurveyGuard>
          }
        />
        {/* Redirect base /surveys to home */}
        <Route path="/surveys" element={<Navigate to="/" replace />} />
        <Route path="profiles" element={<Profiles />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="for-companies" element={<ForCompanies />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        
        {/* Catch-all fallback for invalid URLs or extra slashes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
